var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.show)?_c('div',{staticClass:"spinner",style:({
  background: _vm.show ? `conic-gradient(${_vm.spinnerColor}, ${_vm.spinnerColor},
  transparent, transparent)` : 'transparent'})},[_c('div',{staticClass:"spinner-background",style:({backgroundColor: _vm.bgColor})}),_c('div',{staticClass:"spinner-round-start",style:({backgroundColor: _vm.show ? _vm.spinnerColor : 'transparent'})})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }